<template>
  <ContentContainer :loadingStatus="isLoading">
    <div class="general content-wrapper">
      <div class="page-header">{{ $t('general') }}</div>
      <el-container>
        <el-main>
          <el-row class="company-logo">
            <img v-if="companyDetail.logoUrl !== ''" width="150px" alt="Contract Manager logo" :src="companyDetail.logoUrl">
            <img v-if="companyDetail.logoUrl === ''" width="150px" alt="Contract Manager logo" src="@/assets/logo_placeholder.png">
          </el-row>
          <el-row class="company-currency">
            <div>
              <strong>{{ $t('currency') }}:</strong>
            </div>
            <div>
              {{ companyDetail.currency }}
            </div>
          </el-row>
          <el-row class="company-contract-ref-code-format">
            <div>
              <strong>{{ $t('contractRefCodeFormat') }}:</strong>
              <ref-code-formatting-help-component
                :button-size="'mini'"
                :button-type="'icon'"
                :is-contract-ref-code="true"
                :is-special-offer-ref-code="false">
              </ref-code-formatting-help-component>
            </div>
            <div v-if="companyDetail.contract.refCodeFormat === ''">-</div>
            <div>
              {{ companyDetail.contract.refCodeFormat }}
            </div>
          </el-row>
          <el-row class="company-contract-ref-code-format">
            <div>
              <strong>{{ $t('specialOfferRefCodeFormat') }}:</strong>
              <ref-code-formatting-help-component
                :button-size="'mini'"
                :button-type="'icon'"
                :is-contract-ref-code="false"
                :is-special-offer-ref-code="true">
              </ref-code-formatting-help-component>
            </div>
            <div v-if="companyDetail.specialOffer.refCodeFormat === ''">-</div>
            <div>
              {{ companyDetail.specialOffer.refCodeFormat }}
            </div>
          </el-row>
          <el-row class="row-footer">
            <el-button type="primary" @click="onEditButtonClick">{{ $t('edit') }}</el-button>
          </el-row>
        </el-main>
      </el-container>
    </div>
  </ContentContainer>
</template>

<script>
import i18nMessages from '@/translations/Setting/ManageSetting/General/Index.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import SettingApi from '@/api/setting-api'
import ContentContainer from '@/components/ContentContainerComponent.vue'
import RefCodeFormattingHelpComponent from '@/views/Setting/ManageSetting/General/components/RefCodeFormattingHelpComponent'
import { STATUS } from '@/configs/constant'
import { get } from 'lodash'

export default {
  name: 'SettingGeneral',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: { RefCodeFormattingHelpComponent, ContentContainer },
  i18n: { messages: i18nMessages },
  created: async function () {
    this.isLoading = true

    await this.getSettingDetail()

    this.isLoading = false
  },
  data () {
    return {
      isLoading: false,
      companyDetail: {
        id: '',
        name: '',
        code: '',
        logoUrl: '',
        currency: 'THB',
        contract: {
          refCodeFormat: ''
        },
        specialOffer: {
          refCodeFormat: ''
        },
        companyType: 0,
        isEnable: STATUS.ENABLE
      }
    }
  },
  methods: {
    getSettingDetail: async function () {
      const companyDetail = await SettingApi.info()

      const currency = get(companyDetail, 'currency', 'THB')
      const contractRefCodeFormat = get(companyDetail, 'contract.refCodeFormat', '')
      const specialOfferRefCodeFormat = get(companyDetail, 'specialOffer.refCodeFormat', '')
      const defaultData = {
        currency: currency,
        contract: {
          refCodeFormat: contractRefCodeFormat
        },
        specialOffer: {
          refCodeFormat: specialOfferRefCodeFormat
        }
      }

      this.companyDetail = Object.assign({}, this.companyDetail, companyDetail, defaultData)
    },
    onEditButtonClick: async function () {
      this.$router.push({
        name: 'EditSettingGeneral',
        params: {
          companyDetail: this.companyDetail
        }
      })
    }
  }
}
</script>

<style scoped>
  .el-header {
    background-color: #f8f9fa;
    color: #2c3e50;
    text-align: center;
    line-height: 60px;
    font-weight: bold;
  }
  .el-row {
    font-size: 14px;
    padding: 10px 0;
    border-bottom: 1px #dadbdd solid;
  }
  .el-container {
    width: 80%;
    margin: 0 auto;
  }
  .company-logo {
    border: 0 !important;
    margin: 0 auto 20px;
    text-align: center;
  }

  .row-footer {
    border: 0;
    text-align: center;
    margin-top: 20px;
  }
</style>
